// import { FC, memo, useContext, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import { format } from "date-fns";
// import { NotTreatedData } from "src/pages/actionDashboard/types";
// import ManufacturerNextStepActions from "../manufactureNextStepActions";
// import { useOnClickOutside } from "src/hooks/useClickOutside";
// import { isMobileOrTablet } from "src/helpers";
// import {OverlayTrigger, Tooltip} from "react-bootstrap";
// import WidgetWithTooltip from "../WidgetTooltip";
// import { AuthContext } from "src/context/authContext";

// type Props = {
//   row: NotTreatedData;
//   refreshListing: () => void;
//   index: number
// };

// const PendingTableRow: FC<Props> = ({ row, refreshListing, index }) => {

//   const toggleIconRef = useRef<HTMLElement | null>(null);
//   const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
//   const { isManufacturer } = useContext(AuthContext);

//   useOnClickOutside(toggleIconRef, () => {
//     changeInfoIconIndex(-1);
//   });

//   return (
//     <tr>
//       {/* <td className="text-center align-middle">
//         {row.patient_name !== "Redacted" ? (
//           <Link to={`/global_patients/${row.patient_id}`}>
//             {row.patient_name}
//           </Link>
//         ) : (
//           row.patient_name
//         )}
//       </td> */}
//       {/* <td className="text-center align-middle">
//         {row.patient_initials_dob}
//       </td> */}
//      {row.patient_name !== "Redacted" ? (
//         <td className="text-center align-middle">
//           <Link to={`/global_patients/${row.patient_id}/${row.bi_case_id}${isManufacturer ? "" : "/edit"}`}>
//             {row.patient_initials_dob}
//           </Link>
//         </td>
//       ):<td></td> }
//       <td className="text-center align-middle">
//         <Link
//           to={`/cases/detail/${row.bi_case_id}`}
//         >
//           {row.original_id}
//         </Link>
//       </td>
//       {/* <td className="text-center align-middle">
//         {row.auto_transfer ? (
//           <i className="fa fa-check text-success"></i>
//         ) : (
//           <i className="fa fa-times text-danger"></i>
//         )}
//       </td> */}
//       {/* <td className="text-center align-middle">
//         {row.drug_name === "iovera°" ? row.drug_name : row.drug_name === "zilretta" ? row.drug_name.toUpperCase() : row.drug_name}


//       </td> */}
//       <td className="text-center align-middle">
//         {row.bi_submitted && format(row.bi_submitted, "MM/dd/yyyy")}
//       </td>
//       <td className="text-center align-middle">
//         {row.bi_completed && format(row.bi_completed, "MM/dd/yyyy")}
//       </td>
//       <td className="text-center align-middle">{row.pa_required}</td>
//       <td className="text-center align-middle">{row.insurance_type}</td>
      

//       {/* <td className="text-center align-middle">
//         {row.region}
//       </td>
//       <td className="text-center align-middle">
//         {row.territory}
//       </td>
//       <td className="text-center align-middle">
//         {row.state}
//       </td> */}

//       {/* Medical Coverage */}
//       {/* <td className="text-center align-middle">
//         <span className={`badge background-color-${row.medical_coverage_status_color}`}>
//           {row.medical_coverage_status}
//         </span>
//       </td> */}
//       {/* <td className="text-center align-middle">
//       <ManufacturerNextStepActions refreshListing={refreshListing} kase={row} next_steps={row.next_steps}/>
//       </td> */}

//       {/* Pharmacy Coverage */}
//       <td className="text-center align-middle">
//         <span className={`badge ${row.pharmacy_coverage_status_color}`}>
//           {row.pharmacy_coverage_status}
//         </span>
//       </td>
//       <td className="text-center align-middle">
//         <WidgetWithTooltip caseId={row.bi_case_id} physician={row.provider ?? ""} practice={row.practice ?? {}} />
//       </td>
//       {/* <td className="align-middle">
//           {row.copay_status}
//       </td> */}
//       {/* <td className="text-center fw-bold align-middle">
//         {row.next_steps ? row.next_steps.next_step_verbiage || "" : ""}

//       </td> */}
//     </tr>
//   );
// };

// export default memo(PendingTableRow);


import { FC, memo, useContext, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { NotTreatedData } from "src/pages/actionDashboard/types";
import ManufacturerNextStepActions from "../manufactureNextStepActions";
import { useOnClickOutside } from "src/hooks/useClickOutside";
import { isMobileOrTablet } from "src/helpers";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import WidgetWithTooltip from "../WidgetTooltip";
import { AuthContext } from "src/context/authContext";

type Props = {
  row: NotTreatedData;
  refreshListing: () => void;
  index: number
};

const PendingTableRow: FC<Props> = ({ row, refreshListing, index }) => {

  const toggleIconRef = useRef<HTMLElement | null>(null);
  const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  const { isManufacturer } = useContext(AuthContext);

  useOnClickOutside(toggleIconRef, () => {
    changeInfoIconIndex(-1);
  });

  return (
    <tr>
      {/* <td className="text-center align-middle">
        {row.patient_name !== "Redacted" ? (
          <Link to={`/global_patients/${row.patient_id}`}>
            {row.patient_name}
          </Link>
        ) : (
          row.patient_name
        )}
      </td> */}
      {/* <td className="text-center align-middle">
        {row.patient_initials_dob}
      </td> */}
      <td className="text-center align-middle">
        {row.patient_name !== "Redacted" && row.patient_initials_dob ? (
          <Link to={`/global_patients/${row.patient_id}/${row.bi_case_id}`}>
            {row.patient_initials_dob}
          </Link>
        ) : (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>SF submitted is outdated</Tooltip>}
          >
            <i className="fas fa-info-circle text-color-yellow" style={{ color: "#f2ba45" }}></i>
          </OverlayTrigger>
        )}
      </td>
      <td className="text-center align-middle">
        <Link
          to={`/cases/detail/${row.bi_case_id}`}
        >
          {row.original_id}
        </Link>
      </td>
      {/* <td className="text-center align-middle">
        {row.auto_transfer ? (
          <i className="fa fa-check text-success"></i>
        ) : (
          <i className="fa fa-times text-danger"></i>
        )}
      </td> */}
      {/* <td className="text-center align-middle">
        {row.drug_name === "iovera°" ? row.drug_name : row.drug_name === "zilretta" ? row.drug_name.toUpperCase() : row.drug_name}


      </td> */}
      <td className="text-center align-middle">{row.review_type}</td>
      <td className="text-center align-middle">{row.released}</td>
      <td className="text-center align-middle">
        {row.bi_completed && format(row.bi_completed, "MM/dd/yyyy")}
      </td>
      <td className="text-center align-middle">{row.pa_required}</td>
      <td className="text-center align-middle">{row.pa_status}</td>
      <td className="text-center align-middle">{row.clinical_received}</td>
      <td className="text-center align-middle">{row.insurance_type}</td>
      <td className="text-center align-middle">{row.refills}</td>
      <td className="text-center align-middle">{row.qty}</td>
       <td className="text-center align-middle">{row.lomn_received}</td>


      {/* <td className="text-center align-middle">
        {row.region}
      </td>
      <td className="text-center align-middle">
        {row.territory}
      </td>
      <td className="text-center align-middle">
        {row.state}
      </td> */}

      {/* Medical Coverage */}
      {/* <td className="text-center align-middle">
        <span className={`badge background-color-${row.medical_coverage_status_color}`}>
          {row.medical_coverage_status}
        </span>
      </td> */}
      {/* <td className="text-center align-middle">
      <ManufacturerNextStepActions refreshListing={refreshListing} kase={row} next_steps={row.next_steps}/>
      </td> */}

      {/* Pharmacy Coverage */}
      <td className="text-center align-middle">
        <span className={`badge ${row.pharmacy_coverage_status_color}`}>
          {row.pharmacy_coverage_status}
        </span>
      </td>
      <td className="text-center align-middle">
        <WidgetWithTooltip caseId={row.bi_case_id} physician={row.provider ?? ""} practice={row.practice ?? {}} />
      </td>
      {/* <td className="align-middle">
          {row.copay_status}
      </td> */}
      {/* <td className="text-center fw-bold align-middle">
        {row.next_steps ? row.next_steps.next_step_verbiage || "" : ""}

      </td> */}
    </tr>
  );
};

export default memo(PendingTableRow);